var exports = {
  "_o": "xa15a2ab7--400f96--calltracking_badge",
  "Iz": "xa15a2ab7--400f96--calltracking_badge-text",
  "b0": "xa15a2ab7--400f96--calltracking_badge-description",
};

module.exports = exports;
